import OpacityToggle from '../../../../../components/OpacityToggle/OpacityToggle';
import Paragraph from '../../../../../components/Paragraph/Paragraph';
import useTrans from '../../../../../hooks/ui/useTrans';
import DatePickerMode from '../../../../../types/DatePickerMode';
import supportsBothMultiAndSingleDay from '../../../../helpers/supportsBothMultiAndSingleDay';

import styles from './OnlySingleOrMultiDayMessage.module.css';

type OnlySingleOrMultiDayMessageProps = {
    singleOrMultiDay: DatePickerMode;
    show: boolean;
};

const OnlySingleOrMultiDayMessage = ({
    singleOrMultiDay,
    show,
}: OnlySingleOrMultiDayMessageProps) => {
    const trans = useTrans(
        'CustomerArea.BookingForm.OnlySingleOrMultiDayMessage.'
    );

    if (supportsBothMultiAndSingleDay(singleOrMultiDay)) {
        return null;
    }

    return (
        <OpacityToggle show={show} style={{ position: 'absolute', inset: 0 }}>
            <div className={styles.Root}>
                <div className={styles.Content}>
                    <Paragraph bold flex>
                        {trans(singleOrMultiDay)}
                    </Paragraph>
                </div>
            </div>
        </OpacityToggle>
    );
};

export default OnlySingleOrMultiDayMessage;
